<script>
import format from 'date-fns/format'
import ptBR from 'date-fns/locale/pt-BR'

export default {
  props: {
    faturamentoGuias: Array,
    selectedFaturamentoGuias: { type: Array, required: true },
    conciliacaoGuiasSelected: Array,
    conciliacaoItems: Array
  },
  data () {
    return {
      headers: [
        { value: 'guiaAssociada', text: '', align: 'end', show: true, disableSwitch: true },
        { value: 'quantidadeItensConciliados', text: 'Conc.', align: 'end', show: true },
        { value: 'lote', text: 'Lote', align: 'end', show: true },
        { value: 'numeroGuiaPrestador', text: 'Nº guia prestador', align: 'end', show: true },
        { value: 'numeroGuiaOperadora', text: 'Nº guia operadora', align: 'end', show: true },
        { value: 'senha', text: 'Senha', align: 'end', show: true },
        { value: 'valorTotal', text: 'Valor informado', align: 'end', show: true },
        { value: 'valorPago', text: 'Valor pago', align: 'end', show: true },
        { value: 'valorGlosa', text: 'Valor glosado', align: 'end', show: true },
        { value: 'saldo', text: 'Saldo', align: 'end', show: true },
        { value: 'beneficiario', text: 'Beneficiário', show: true },
        { value: 'cronograma', text: 'Cronograma', show: true },
        { value: 'quantidadeItens', text: 'Itens', align: 'end', show: true },
        { value: 'id', text: 'Id', align: 'end', show: true }
      ],
      inputs: [
        { key: 'numeroGuiaPrestador', label: 'Número guia prestador' },
        { key: 'numeroGuiaOperadora', label: 'Número guia operadora' },
        { key: 'numeroGuiaPrincipal', label: 'Número guia principal' },
        { key: 'numeroGuiaSolicitacao', label: 'Número guia solicitação' },
        { key: 'senha', label: 'Senha' },
        { key: 'numeroCarteira', label: 'Número carteira' }
      ],
      inputFilters: {},
      count: 0,
      sortingColumnsValues: [
        { text: 'Valor Informado', value: 'valorTotal' },
        { text: 'Número guia prestador', value: 'numeroGuiaPrestador' },
        { text: 'Número guia operadora', value: 'numeroGuiaOperadora' },
        { text: 'Senha', value: 'senha' },
        { text: 'Nome beneficiário', value: 'nomeBeneficiario' },
        { text: 'Número carteira', value: 'numeroCarteira' },
      ],
      sortingOrderValues: [
        { text: 'Crescente', value: 'asc' },
        { text: 'Decrescente', value: 'desc' }
      ],
      sortingQuery: [{ value: '', direction: 'asc' }],
      desassociarFaturamentoGuiasDialogOpen: false,
      associarGuiasDialogOpen: false
    }
  },
  computed: {
    computedSelectedFaturamentoGuias: {
      get () {
        return this.$props.selectedFaturamentoGuias
      },
      set (value) {
        this.$emit('selectedFaturamentoGuiasChange', value)
      }
    },
    showBadge () {
      return this.count > 0
    },
    sortCount () {
      return  this.sortingQuery
        .filter(sort => Boolean(sort.value))
        .length
    },
    showSortBadge () {
      return this.sortCount > 0
    },
    faturamentoAcoesDialog () {
      return this.associarGuiasDialogOpen || this.desassociarFaturamentoGuiasDialogOpen
    },
    selectedFaturamentoGuiaIds () {
      return this.computedSelectedFaturamentoGuias.map(faturamentoGuia => faturamentoGuia.id)
    },
    pagamentoItemIds () {
      return this.conciliacaoItems
        .filter(conciliacaoItem => this.selectedFaturamentoGuiaIds.includes(conciliacaoItem.faturamentoGuiaId))
        .map(conciliacaoItem => conciliacaoItem.pagamentoItemId)
    }
  },
  methods: {
    updateCount () {
      this.count = Object.values(this.inputFilters)
        .filter(value => Boolean(value))
        .length
    },
    handleClearFilter () {
      this.inputFilters = {}
      this.updateCount()
      this.$emit('faturamentoGuiaFilterChange', this.inputFilters)
    },
    debouncedFilterChange (key, value) {

      clearTimeout(this._timerId)
      this._timerId = setTimeout(() => {
        this.inputFilters[key] = value
        this.updateCount()
        this.$emit('faturamentoGuiaFilterChange', this.inputFilters)
      }, 500)
    },
    addNewSort () {
      this.sortingQuery.push({
        value: null,
        direction: 'asc'
      })
    },
    cleanSort () {
      this.sortingQuery = [{ value: null, direction: 'asc' }]

      this.$emit('faturamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    removeSort (index) {
      this.sortingQuery.splice(index, 1)

      this.$emit('faturamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    updateSortValue (index, newValue) {
      this.sortingQuery[index].value = newValue

      this.$emit('faturamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    updateSortDirection (index, newDirection) {
      this.sortingQuery[index].direction = newDirection

      this.$emit('faturamentoGuiaOrderQueryChange', this.sortingQuery)
    },
    handleDesconciliarClick () {
      if (this.pagamentoItemIds.length === 0) {
        const paramModal = {
          type: "warning",
          title: "Desconciliar itens",
          message: "Não é possível desconciliar itens não conciliados com este pagamento.",
          btConfirm: { name: "Ok", show: true }
        };
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      } else {
        const query = {
          pagamentoItemIds: this.pagamentoItemIds
        }
        this.$emit('clickDesconciliar', query)
      }
    },
    handleDesassociarClick () {
      const selectedGuiasAssociadas = this.conciliacaoGuiasSelected
        ?.map(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId
          .map(faturamentoGuiaId => {
            return {
              faturamentoGuiaId,
              pagamentoGuiaId: conciliacaoGuia.pagamentoGuiaId
            }
          }))
        .flat()

      this.$emit('clickDesassociar', selectedGuiasAssociadas)
      this.desassociarFaturamentoGuiasDialogOpen = false
    },
    handleAssociarClick () {
      this.associarGuiasDialogOpen = false
      this.$emit('clickAssociar')
    },
    handleGuiaAssociadaChipClick (faturamentoGuiaId) {
      const pagamentoGuiasId = this.conciliacaoGuiasSelected
        ?.filter(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId.includes(faturamentoGuiaId))
        .map(conciliacaoGuia => conciliacaoGuia.pagamentoGuiaId) || []

      const guiasAssociadas = {
        faturamentoGuiasId: [faturamentoGuiaId],
        pagamentoGuiasId
      }

      this.$emit('guiaAssociadaChipClick', guiasAssociadas)
    },
    guiaAssociadaChip (faturamentoGuiaId) {
      const indexes = this.conciliacaoGuiasSelected
        ?.filter(conciliacaoGuia => conciliacaoGuia.faturamentoGuiasId.includes(faturamentoGuiaId))
        .map(conciliacaoGuia => conciliacaoGuia.index + 1)

      return indexes?.join(', ') || ''
    },
  },
  filters: {
    formatPercent(value) {
      const formatter = new Intl.NumberFormat('pt-BR', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 })
      return formatter.format(value)
    },
    formatDate (date) {
      if (date?.toString().match(/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/)) {
        const match = date.toString().match(/([0-9]{4})-([0-9]{2})-([0-9]{2})/)

        return `${match[3]}/${match[2]}/${match[1]}`
      }

      return date ? format(new Date(date), 'P', { locale: ptBR }) : '-'
    },
    pluralize (count) {
      if (count === 0) {
        return 'Nenhuma guia selecionada'
      } else if (count === 1) {
        return '1 guia selecionada'
      } else {
        return `${count} guias selecionadas`
      }
    }
  }
}
</script>

<template>
  <div class="datatable-container">
    <div class="d-flex align-center justify-space-around">
      <div style="width: 100%;">
        <h3 class="pl-4">Guias de faturamento</h3>
      </div>
      <div v-if="selectedFaturamentoGuias.length > 0" class="primary--text" style="width: 100%;">{{ selectedFaturamentoGuias.length | pluralize }} de {{ faturamentoGuias.length }}</div>
      <div class="d-flex align-center pr-4" style="column-gap: 16px;">
        <v-menu
          :close-on-content-click="false"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showBadge"
              :content="count"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" class="mt-1" color="primary" x-small outlined>
                <v-icon dense x-small left>fa-filter</v-icon>
                FILTRAR
              </v-btn>
            </v-badge>
          </template>
          <div class="d-flex flex-column px-6 pt-4" style="background-color: white; max-height: 36vh; overflow: auto;">
            <v-text-field
              class="py-2"
              v-for="item in inputs"
              @input="value => debouncedFilterChange(item.key, value)"
              :value="inputFilters[item.key]"
              :key="item.key"
              :label="item.label"
              outlined
              clearable
              dense
              hide-details
            />
            <div style="display: flex; justify-content: end; background-color: #FFF; padding-bottom: 8px;">
              <v-btn
                @click="handleClearFilter"
                color="primary"
                text
                x-small
              >
                Limpar
              </v-btn>
            </div>
          </div>
        </v-menu>
        <v-menu
          :close-on-content-click="false"
          offset-y
          left
        >
          <template v-slot:activator="{ on, attrs }">
            <v-badge
              :value="showSortBadge"
              :content="sortCount"
              class="white--text"
              color="primary"
              offset-y="15px"
              offset-x="7px"
            >
              <v-btn v-bind="attrs" v-on="on" color="primary" class="mt-1" x-small outlined>
                <v-icon dense x-small left>fa-sort-amount-down</v-icon>
                Ordenar
              </v-btn>
            </v-badge>
          </template>
          <div style="background-color: #FFF;">
            <v-list>
              <v-list-item
                v-for="(sort, index) in sortingQuery"
                :key="index"
              >
                <div class="d-flex align-center">
                  <v-select
                    @change="event => updateSortValue(index, event)"
                    :items="sortingColumnsValues"
                    :value="sort.value"
                    :style="'width: 240px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                  <v-select
                    @change="event => updateSortDirection(index, event)"
                    :items="sortingOrderValues"
                    :value="sort.direction"
                    :style="'width: 152px'"
                    class="mr-2"
                    outlined
                    dense
                    hide-details
                  />
                    <v-btn
                      v-if="sortingQuery.length > 1"
                      @click="() => removeSort(index)"
                      icon
                    >
                    <v-icon color="primary">mdi-minus-circle</v-icon>
                  </v-btn>
                </div>
              </v-list-item>
            </v-list>
            <v-btn
              @click="addNewSort"
              color="primary"
              class="ml-4 mr-1 mb-4"
              rounded
              x-small
            >
              Adicionar
            </v-btn>
            <v-btn
              @click="cleanSort"
              color="primary"
              outlined
              rounded
              x-small
              class="mb-4"
            >
              Limpar
            </v-btn>
          </div>
        </v-menu>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="mt-1 mr-1"
              color="primary"
              x-small
              outlined
              v-bind="attrs"
              v-on="on"
              :disabled="selectedFaturamentoGuias.length === 0"
            >
              AÇÕES
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="() => associarGuiasDialogOpen = true">
              ASSOCIAR
            </v-list-item>
            <v-list-item @click="() => desassociarFaturamentoGuiasDialogOpen = true">
              DESASSOCIAR
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    <v-data-table
      :headers="headers"
      fixed-header
      :height="'calc(50vh - 90px)'"
      :items="faturamentoGuias"
      :loading-text="'Carregando...'"
      :footer-props="{
        'items-per-page-options': [10, 25, 50]
      }"
      item-key="id"
      class="text-no-wrap"
      dense
      :disable-pagination="true"
      :hide-default-footer="true"
      show-select
      v-model="computedSelectedFaturamentoGuias"
    >
      <template v-slot:item.guiaAssociada="{ item }">
        <v-chip
          v-if="guiaAssociadaChip(item.id)"
          class="pa-1"
          x-small
          outlined
          @click="handleGuiaAssociadaChipClick(item.id)"
        >
          {{ guiaAssociadaChip(item.id) }}
        </v-chip>
      </template>

      <template v-slot:item.quantidadeItensConciliados="{ item }">
        {{ item.quantidadeItensConciliados / item.quantidadeItens | formatPercent}}
      </template>

      <template v-slot:item.beneficiario="{ item }">
        <div class="d-flex flex-column">
          <div class="text-body-2">{{ item.nomeBeneficiario }}</div>
          <div class="caption">{{ item.numeroCarteira || '-' }}</div>
        </div>
      </template>

      <template v-slot:item.numeroGuiaPrestador="{ item }">
        {{ item.numeroGuiaPrestador || '-' }}
      </template>

      <template v-slot:item.numeroGuiaOperadora="{ item }">
        {{ item.numeroGuiaOperadora || '-' }}
      </template>

      <template v-slot:item.lote="{ item }">
        {{ item.lote?.numeroLote || '-' }}
      </template>

      <template v-slot:item.cronograma="{ item }">
        {{(item.lote?.cronograma.dataFaturamento || null) | formatDate }}
      </template>

      <template v-slot:item.dataExecucao="{ item }">
        {{ item.dataExecucao | formatDate }}
      </template>

      <template v-slot:item.valorTotal="{ item }">
        {{ item.valorTotal | formatPrice }}
      </template>

      <template v-slot:item.valorPago="{ item }">
        {{ item.valorPago | formatPrice }}
      </template>

      <template v-slot:item.valorGlosa="{ item }">
        {{ item.valorGlosa | formatPrice }}
      </template>

      <template v-slot:item.saldo="{ item }">
        {{ (item.valorTotal - item.valorPago) | formatPrice }}
      </template>

    </v-data-table>
    <v-dialog
      v-model="faturamentoAcoesDialog"
      @click:outside="() => {
        desassociarFaturamentoGuiasDialogOpen = false
        associarGuiasDialogOpen = false
      }"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          {{ associarGuiasDialogOpen ? 'Associar' : 'Desassociar' }} guias de faturamento
        </v-card-title>
        <v-card-text>
          Esta ação vai {{ associarGuiasDialogOpen ? 'associar' : 'desassociar' }} as guias de faturamento selecionadas.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="() => {
            if (associarGuiasDialogOpen) {
              handleAssociarClick()
            } else {
              handleDesassociarClick()
            }
          }">Confirmar</v-btn>
          <v-btn @click="() => {
            desassociarFaturamentoGuiasDialogOpen = false
            associarGuiasDialogOpen = false
          }">
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.datatable-container {
  border: 1px solid rgb(204, 204, 204);
}
</style>
